module.exports = __webpack_public_path__ + "img/person_stalker_icon.fd3dcb71.png";